import { Link } from 'react-router-dom';
import Reveal from '@/components/base/Reveal';
import { epinSpotlight } from '@/mocks/epin';

export default function EpinSpotlight() {
  const d = epinSpotlight;

  return (
    <section id="epin-spotlight" className="w-full bg-background-100 py-16 md:py-24">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <Reveal>
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 lg:gap-14 items-center">
            {/* 文案 */}
            <div>
              <span className="inline-flex items-center gap-1.5 px-3 py-1 rounded-full bg-accent-100 text-accent-900 text-xs font-semibold tracking-wide whitespace-nowrap">
                <i className="ri-qr-code-line"></i>
                {d.eyebrow}
              </span>
              <h2 className="mt-4 font-heading font-bold text-2xl md:text-4xl text-foreground-950 leading-snug">
                {d.title}
              </h2>
              <p className="mt-4 text-sm md:text-base text-foreground-700 leading-relaxed">
                {d.desc}
              </p>

              <ul className="mt-6 grid grid-cols-1 sm:grid-cols-2 gap-x-6 gap-y-3">
                {d.points.map((p) => (
                  <li key={p} className="flex items-start gap-2.5">
                    <span className="w-5 h-5 shrink-0 mt-0.5 flex items-center justify-center rounded-full bg-primary-100 text-primary-700">
                      <i className="ri-check-line text-xs"></i>
                    </span>
                    <span className="text-sm text-foreground-700 leading-relaxed">{p}</span>
                  </li>
                ))}
              </ul>

              <div className="mt-8 flex flex-wrap gap-3">
                <Link
                  to={d.href}
                  className="inline-flex items-center gap-2 px-6 py-3 rounded-md bg-primary-500 text-background-50 text-sm font-medium whitespace-nowrap cursor-pointer transition-colors hover:bg-primary-600"
                >
                  {d.primaryCta}
                  <i className="ri-arrow-right-line text-base"></i>
                </Link>
                <Link
                  to={d.secondaryHref}
                  className="inline-flex items-center gap-2 px-6 py-3 rounded-md bg-background-50 border border-background-300 text-foreground-700 text-sm whitespace-nowrap cursor-pointer transition-colors hover:border-accent-400 hover:text-accent-800"
                >
                  <i className="ri-shield-check-line"></i>
                  {d.secondaryCta}
                </Link>
              </div>
            </div>

            {/* 视觉 */}
            <div className="relative">
              <div className="w-full aspect-[4/3] rounded-lg overflow-hidden border border-background-300 bg-foreground-950">
                <img
                  src={d.imageUrl}
                  alt="ePin食安码 一物一码全链路溯源"
                  title="华辉数智 ePin食安码"
                  className="w-full h-full object-cover object-top"
                />
              </div>
              <div className="absolute -bottom-5 left-5 sm:left-8 flex items-center gap-3 rounded-lg bg-background-50 border border-background-200 px-4 py-3">
                <span className="w-10 h-10 flex items-center justify-center rounded-md bg-accent-100 text-accent-800">
                  <i className="ri-route-line text-xl"></i>
                </span>
                <div>
                  <div className="font-heading font-bold text-sm text-foreground-950">全链路可追溯</div>
                  <div className="text-xs text-foreground-500">生产 · 质检 · 仓储 · 运输 · 销售 · 消费</div>
                </div>
              </div>
            </div>
          </div>
        </Reveal>
      </div>
    </section>
  );
}